import type { QuoteResult } from "../lib/premiums";

interface PremiumResultProps {
  result: QuoteResult;
  currency: string;
}

const RESULT_NOTE =
  "Premiums are monthly and inclusive of the family rate where applicable.";

function formatAmount(currency: string, amount: number): string {
  return `${currency}${amount.toLocaleString("en-ZA")}`;
}

/** Shows the monthly premium, or the max-entry-age / min-age messages. */
export function PremiumResult({ result, currency }: PremiumResultProps) {
  if (result.status === "over-max") {
    return (
      <div className="result result--message" role="status">
        <p className="result__message">
          This option is available up to maximum entry age of{" "}
          {result.maxEntryAge}. Please contact us to discuss your options.
        </p>
      </div>
    );
  }

  if (result.status === "below-min") {
    return (
      <div className="result result--message" role="status">
        <p className="result__message">
          Please enter an age of {result.minEntryAge} or older for the
          principal insured.
        </p>
      </div>
    );
  }

  if (result.status !== "ok") {
    return (
      <div className="result result--message" role="status">
        <p className="result__message">
          Select a plan to see your monthly premium.
        </p>
      </div>
    );
  }

  return (
    <div className="result" role="status" aria-live="polite">
      <span className="result__caption">Your estimated monthly premium</span>
      <span className="result__amount">
        {formatAmount(currency, result.premium)}
        <span className="result__period"> / month</span>
      </span>
      <p className="result__note">{RESULT_NOTE}</p>
    </div>
  );
}
